import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import { GridRowId, GridValidRowModel } from '@mui/x-data-grid'
import ReactMarkdown from 'react-markdown'

import { FplDialogTitle } from 'components/common/Dialog'

interface IProps {
  selectedLogRecordId: GridRowId | null
  openDialog: boolean
  handleCloseDialog: () => void
  getLogRecord: (id: GridRowId) => GridValidRowModel | undefined
}

const ViewAccountPayableRecordLog = ({
  selectedLogRecordId,
  openDialog,
  handleCloseDialog,
  getLogRecord,
}: IProps) => {
  const logRecord = selectedLogRecordId === null ? undefined : getLogRecord(selectedLogRecordId)

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={openDialog}
      onClose={handleCloseDialog}
      aria-labelledby='account-payable-record-log-dialog-title'>
      <FplDialogTitle id='account-payable-record-log-dialog-title' onClose={handleCloseDialog}>
        <Typography paragraph variant='h4'>
          {(logRecord?.reason ?? 'Account Payable History').toUpperCase()}
        </Typography>
      </FplDialogTitle>

      <DialogContent>
        <Box>
          <Typography>Audit Record ID: {logRecord?.id ?? selectedLogRecordId}</Typography>
        </Box>
        <Box mt={2}>
          <Typography variant='subtitle1'>Details:</Typography>
          <ReactMarkdown>{logRecord?.details ?? 'No further details available'}</ReactMarkdown>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant='contained' onClick={handleCloseDialog}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewAccountPayableRecordLog
